import React, { memo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Button from 'src/components/Button';

import theme from 'src/styles/components/SubmitOrderButton.module.scss';

const SubmitOrderButton = memo(({
    context,
    submitOrder,
    isSubmitOrderPending,
    canOrder
}) => {
    const intl = useIntl();

    const handleOrder = useCallback(() => {
        if (!isSubmitOrderPending) {
            submitOrder(context);
        }
    }, [context, isSubmitOrderPending]);

    return (
        <Button
          className={theme.button}
          onClick={handleOrder}
          disabled={!canOrder}
          raised
          accent
        >{intl.formatMessage({ id: 'App.makeOrder' })}</Button>
    );
});

SubmitOrderButton.propTypes = {
    context: PropTypes.object,
    submitOrder: PropTypes.func.isRequired,
    isSubmitOrderPending: PropTypes.bool.isRequired,
    canOrder: PropTypes.bool.isRequired
};

export default SubmitOrderButton;
